import { Component, Input } from '@angular/core';

import { IconPosition } from '../../new-button.component';

@Component({
  selector: 'broker-button-add-svg',
  templateUrl: './add-svg.component.svg'
})
export class AddSvgComponent {
  @Input() position: IconPosition = 'left';
}
